<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="is-flex">
    <!--    <router-link :to="{ name: ROUTE_NAMES.NOTIFICATIONS }">-->
    <!--      <div title="Show restrictions" class="warning-icon">-->
    <!--        <WarningIcon width="24px" height="24px"></WarningIcon>-->
    <!--      </div>-->
    <!--    </router-link>-->
    <router-link
      :title="$t('Opening hours - click for more info')"
      :to="{ name: ROUTE_NAMES.VISIT_US }"
    >
      <div class="is-flex" style="align-items: center;">
        <ScheduleIcon
          width="24px"
          height="24px"
          class="schedule-icon"
        ></ScheduleIcon>
        <span class="link full-hours-link"
          >{{
            $t("Today {open}", { open: todayOpen ? $t("open") : $t("closed") })
          }}
          <span v-if="todayOpen">{{
            `${openingHours.from} - ${openingHours.to}`
          }}</span></span
        >
      </div>
    </router-link>
  </div>
</template>
<script>
import ScheduleIcon from "@images/schedule-24px.svg";
// import WarningIcon from "@images/warning-24px.svg";
import { ROUTE_NAMES } from "@/routes";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ScheduleIcon
    // WarningIcon
  },
  computed: {
    ROUTE_NAMES: () => ROUTE_NAMES,
    ...mapGetters({
      todayOpen: "openingHours/open",
      openingHours: "openingHours/hours"
    })
  },
  methods: {
    ...mapActions({ loadHours: "openingHours/load" })
  },
  async mounted() {
    await this.loadHours();
  }
};
</script>
<style scoped lang="scss">
@import "./../../styles/index";
.warning-icon {
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
  }

  svg {
    fill: #ff6e26;
  }
}

.schedule-icon {
  margin-right: 0.5rem;
}

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(
      $primary-theme-color,
      $color-text,
      $color-selection
    );
  }
}
</style>
